import { api } from '@/lib/api';
import type { AdminOrderFilters, AdminOrderListResponse } from './types';

export async function fetch_order_list(filters: AdminOrderFilters): Promise<AdminOrderListResponse> {
  const params: Record<string, string | number> = {};
  if (filters.page) params.page = filters.page;
  if (filters.page_size) params.page_size = filters.page_size;
  if (filters.status) params.status = filters.status;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  if (filters.vendor_profile_id) params.vendor_profile_id = filters.vendor_profile_id;
  const res = await api.get<AdminOrderListResponse>('/admin/orders', { params });
  return res.data;
}
